"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelationDestination = void 0;
var tslib_1 = require("tslib");
var open_xml_relation_1 = require("../../../utils/open-xml-relation");
var destination_1 = require("../destination");
var RelationDestination = (function (_super) {
    tslib_1.__extends(RelationDestination, _super);
    function RelationDestination(data, relations) {
        var _this = _super.call(this, data) || this;
        _this.relations = relations;
        return _this;
    }
    Object.defineProperty(RelationDestination.prototype, "elementHandlerTable", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    RelationDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rel;
            return tslib_1.__generator(this, function (_a) {
                rel = new open_xml_relation_1.OpenXmlRelation(reader.getAttribute('Id'), reader.getAttribute('Target'), reader.getAttribute('Type'), reader.getAttribute('TargetMode'));
                if (!rel.isEmpty())
                    this.relations.add(rel);
                return [2];
            });
        });
    };
    return RelationDestination;
}(destination_1.ElementDestination));
exports.RelationDestination = RelationDestination;
